<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>采购计划获取</h4>
      <div @click="backClick"><i class="fa fa-reply"></i></div>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="采购订单号:" prop="orderID">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.purorderNo"></el-input>
      </el-form-item>
      <el-form-item label="采购日计划号:" prop="orderID">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.purplanNo"></el-input>
      </el-form-item>
      <el-form-item label="供应商:" prop="supplier">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.fromOrg"></el-input>
      </el-form-item>
      <el-form-item label="物料名称:" prop="materialName">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.goodsName"></el-input>
      </el-form-item>
      <el-form-item label="交货日期:" prop="deliveryDate">
        <el-date-picker
          v-model="searchFrom.startTime"
          size="mini"
          style="width: 190px"
          placeholder="选择日期"
          type="date"
          value-format="yyyy-MM-dd"
        ></el-date-picker>&nbsp;-&nbsp;&nbsp;
        <el-date-picker
          v-model="searchFrom.endTime"
          size="mini"
          style="width: 190px"
          placeholder="选择日期"
          type="date"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='001P001B00B' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick" btnCode='001P001B00C' v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addBtnClick" :disabled="createDisable"  btnCode='001P001B00D' v-if="btnFlg[2]">确定</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click = 'handleRowClick'
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="selection" :selectable='selectEnable'  width="55" align="center"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column property="purorderNo" label="采购订单号" width="130" align="center" ></el-table-column>
        <el-table-column prop="purplanNo"    label="采购日计划号" align="center" width="230" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operFlag"   label="获取状态" align="center"  show-overflow-tooltip>
          <template slot-scope="scope"><div>
            <el-tag v-if="scope.row.operFlag==1" type="danger" effect="dark">未获取</el-tag>
            <el-tag v-if="scope.row.operFlag==2" type="success" effect="dark">已获取</el-tag>
          </div></template>
        </el-table-column>
        <el-table-column prop="goodsName"    label="物料名称"  width="100" align="center"></el-table-column>
        <el-table-column prop="goodsNo" label="物料编码" align="center" width="140"></el-table-column>
        <el-table-column prop="purplanWeight"    label="采购吨数" align="center" width="100"></el-table-column>
        <el-table-column prop="toOrg"  label="收货单位" align="center" width="140"></el-table-column>
        <el-table-column prop="warehouseNameShow" label="收货仓库"  align="center" width="150"></el-table-column>
        <el-table-column prop="areaName" label="收货库位"  align="center" ></el-table-column>
        <el-table-column prop="fromOrg"   label="供应商" align="center" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="validDate"    label="交货日期"  width="100" align="center"></el-table-column>
        <el-table-column prop="wharfName" label="港口" align="center" width="140"></el-table-column>
        <el-table-column prop="forwarderName"    label="货代" align="center" width="140"></el-table-column>
        <el-table-column prop="shipName"  label="船名" align="center" width="140"></el-table-column>
        <el-table-column prop="remark" label="备注"  align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column v-if="false" prop="tempPurchasePlanId"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getPurchaseList, // 获取采购
  createPlan // 生成计划
} from '@/api/zhb-sgHarbour'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
export default {
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: ['001P001B00B', '001P001B00C', '001P001B00D'],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        collectPlanTime: '',
        purorderNo: '',
        purplanNo: '',
        fromOrg: '',
        goodsName: '',
        startTime: '',
        endTime: ''
      },
      value: '',
      tableList: [],
      // 新增
      addShengChengLoading: false,
      addFaBuLoading: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      faBuId: '',
      planStatus: '',
      createDisable: false,
      tabLoading: false
    }
  },
  created () {
    // this.getSeatchData(this.searchFrom)
    // this.getDictionary()
    this.getToDay()
    this.btnFlg = getBtn(this.btnIdArr, '/sgPlanManagement/planRelease')
    this.getSeatchData()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  methods: {
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    /**
 * 日期格式化
 */
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 年月日
    timeStamp2 (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log("time:" + JSON.stringify(now));
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      // 早八点之前显示昨天的日期，早八点之后显示今天的日期
      let dateStartStr = this.timeStamp2(new Date(new Date(new Date().toLocaleDateString()).getTime())) // 当天的早8点时间戳
      this.searchFrom.startTime = this.timeStamp2(new Date(dateStartStr).getTime())
      this.searchFrom.endTime = this.timeStamp2(new Date(dateStartStr).getTime() + 86400000)
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      getPurchaseList(this.searchFrom).then(res => {
        this.tabLoading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.tabLoading = false
        // console.log(err.message)
        this.$message.error(err.message)
      })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        startTime: '',
        endTime: ''
      }
      this.getToDay()
      this.getSeatchData(this.searchFrom)
    },
    selectEnable (row, rowIndex) {
      if (row.operFlag == '2') {
        return 0
      }
      return 1
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      if (row.operFlag == 1) {
        this.$refs.tableRef.toggleRowSelection(row)
        this.changeFlag = row.newFlg
        this.changeData = row
        this.faBuId = row.id
        this.planStatus = row.planStatus
      }
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },

    // 获取计划确定
    addBtnClick () {
      this.createDisable = true
      let selectedPlans = this.$refs.tableRef.selection
      if (selectedPlans == null || selectedPlans == '') {
        this.$message.warning('请先选择计划')
        this.createDisable = false
        return
      }
      let planIds = []
      for (let index = 0; index < selectedPlans.length; index++) {
        planIds.push(selectedPlans[index].tempPurchasePlanId)
      }
      console.log(planIds)
      this.$confirm('是否生成计划?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        createPlan(planIds).then(res => {
          this.$message.success('操作成功')
          this.getSeatchData()
          this.createDisable = false
          this.$router.push('/sgPlanManagement/planRelease')
        }).catch(err => {
          this.createDisable = false
          this.$message.error(err.message)
        })
      }).catch(() => {
        this.createDisable = false
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    // 合同列表取消
    heTongQuXiaoClick () {
      this.heTongMark = false
    },
    // 返回
    backClick () {
      this.$router.push('/sgPlanManagement/planRelease')
    }
  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
.searchBox{
  margin-left: 25px;
}
.inpBox{
  margin: 10px 0 0 -30px;
}

//  /deep/ .inpBox .el-range-editor--mini .el-input__inner {
//    width: 150px;
// }
// .inpBox .el-date-editor{
//     width: 280px!important;
//  }
.searchBtnBox{
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.tongJi{
  display: flex;
  margin-left:10px;
}
.tongJi_item{
  margin-right: 20px;
}
.tongJi_item span{
  color: red;
}
</style>
